import {
  CompositeFilterDescriptor,
  FilterDescriptor,
  GroupDescriptor,
  SortDescriptor,
  State,
} from '@progress/kendo-data-query';
import { GridStateCompositeFilterDescriptor } from './grid-state-composite-filter-descriptor.model';
export class GridState implements State {
  restaurantId?: string;
  restaurantIds?: string[];
  productType?: string;
  filter?: GridStateCompositeFilterDescriptor | undefined;
  group?: GroupDescriptor[] | undefined;
  skip?: number | undefined;
  sort?: SortDescriptor[] | undefined;
  take?: number | undefined;

  constructor(
    pageSize?: number,
    sort?: SortDescriptor[],
    restaurantId?: string,
    productType?: string,
    restaurantIds?: string[],
  ) {
    this.restaurantId = restaurantId;
    this.restaurantIds = restaurantIds;
    this.productType = productType;
    this.skip = 0;
    this.take = pageSize;
    this.filter = new GridStateCompositeFilterDescriptor();
    this.sort = sort || [];
  }

  resetPager(pageSize: number) {
    this.skip = 0;
    this.take = pageSize;
  }

  static removeFilterByFields(
    filter: CompositeFilterDescriptor,
    ...fieldsToRemove: string[]
  ): CompositeFilterDescriptor | undefined {
    const newFilters = filter.filters
      .map((f) => {
        if ('filters' in f) {
          return GridState.removeFilterByFields(f, ...fieldsToRemove);
        }

        return f &&
          f.field !== undefined &&
          typeof f.field !== 'function' &&
          !fieldsToRemove.includes(f.field)
          ? f
          : undefined;
      })
      .filter(Boolean) as (FilterDescriptor | CompositeFilterDescriptor)[];

    return newFilters.length > 0
      ? { ...filter, filters: newFilters }
      : undefined;
  }

  static hasField(filter: CompositeFilterDescriptor, field: string): boolean {
    return filter.filters.some((f) => {
      if ('filters' in f) {
        return GridState.hasField(f, field);
      }
      return f.field === field;
    });
  }

  static findField(
    filter: CompositeFilterDescriptor,
    field: string,
  ): FilterDescriptor | undefined {
    for (const f of filter.filters) {
      if ('filters' in f) {
        const result = GridState.findField(
          f as CompositeFilterDescriptor,
          field,
        );
        if (result) return result;
      } else if (f.field === field) {
        return f as FilterDescriptor;
      }
    }
    return undefined;
  }

  static substituteFilterField(
    filter: CompositeFilterDescriptor | undefined,
    currentField: string,
    ...newFields: string[]
  ): CompositeFilterDescriptor | undefined {
    if (filter) {
      let currentFieldFilter = GridState.findField(filter, currentField);

      if (currentFieldFilter != undefined && currentFieldFilter != null) {
        filter = new GridStateCompositeFilterDescriptor(
          GridState.removeFilterByFields(filter, currentField) ??
            new GridStateCompositeFilterDescriptor(),
        );
        let composite = new GridStateCompositeFilterDescriptor();
        newFields.forEach((newField) => {
          composite = composite.or({
            field: newField,
            operator: currentFieldFilter.operator,
            value: currentFieldFilter.value,
          });
        });
        filter = new GridStateCompositeFilterDescriptor(filter).and(composite);
      }
    }

    return filter;
  }

  static getPageSizeByFontSize(fontSize: number): number {
    const screenWidth = window.screen.width;
    if (screenWidth >= 1920 && fontSize <= 1) {
      return 15;
    } else return 10;
  }

  static getPagerOptionsByFontSize(fontSize: number): number[] {
    const min = this.getPageSizeByFontSize(fontSize);
    if (min === 15) {
      // 20 is offered on both lists because the Bundles grid opens on that size
      return [15, 20, 25, 75, 100, 150];
    }
    return [10, 20, 50, 100, 150];
  }
}
